/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SortField {
    Name = 'Name',
    CreatedAtUtc = 'CreatedAtUtc'
}


export function SortFieldFromJSON(json: any): SortField {
    return SortFieldFromJSONTyped(json, false);
}

export function SortFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortField {
    return json as SortField;
}

export function SortFieldToJSON(value?: SortField | null): any {
    return value as any;
}

